import { PageId } from 'constants/pages'

export const enum PageIdStylioArchIo {
  AGE_ARCH_IO = PageId.AGE_ARCH_IO,
  SHOP_SMARTER_ARCH_IO = PageId.SHOP_SMARTER_ARCH_IO,
  STYLIO_TO_HELP_ARCH_IO = PageId.STYLIO_TO_HELP_ARCH_IO,
  MAIN_GOAL_ARCH_IO = PageId.MAIN_GOAL_ARCH_IO,
  WHERE_TO_SHOP_ARCH_IO = PageId.WHERE_TO_SHOP_ARCH_IO,
  WARDROBE_PERCENTAGE_ARCH_IO = PageId.WARDROBE_PERCENTAGE_ARCH_IO,
  HAIR_COLOR_ARCH_IO = PageId.HAIR_COLOR_ARCH_IO,
  EYES_COLOR_ARCH_IO = PageId.EYES_COLOR_ARCH_IO,
  SKIN_COLOR_ARCH_IO = PageId.SKIN_COLOR_ARCH_IO,
  CLIMAT_ARCH_IO = PageId.CLIMAT_ARCH_IO,
  BODY_SHAPE_ARCH_IO = PageId.BODY_SHAPE_ARCH_IO,
  URGE_1_ARCH_IO = PageId.URGE_1_ARCH_IO,
  URGE_2_ARCH_IO = PageId.URGE_2_ARCH_IO,
  URGE_3_ARCH_IO = PageId.URGE_3_ARCH_IO,
  URGE_4_ARCH_IO = PageId.URGE_4_ARCH_IO,
  URGE_5_ARCH_IO = PageId.URGE_5_ARCH_IO,
  URGE_6_ARCH_IO = PageId.URGE_6_ARCH_IO,
  URGE_7_ARCH_IO = PageId.URGE_7_ARCH_IO,
  URGE_8_ARCH_IO = PageId.URGE_8_ARCH_IO,
  URGE_9_ARCH_IO = PageId.URGE_9_ARCH_IO,
  STYLE_PROFILE_ARCH_IO = PageId.STYLE_PROFILE_ARCH_IO,
  WARDROBE_READY_ARCH_IO = PageId.WARDROBE_READY_ARCH_IO,
  NOTHING_TO_WEAR_ARCH_IO = PageId.NOTHING_TO_WEAR_ARCH_IO,
  ARCHETYPE_INTRO_ARCH_IO = PageId.ARCHETYPE_INTRO_ARCH_IO,
  DRESSED_FEEL_ARCH_IO = PageId.DRESSED_FEEL_ARCH_IO,
  STYLE_MATTERS_MOST_ARCH_IO = PageId.STYLE_MATTERS_MOST_ARCH_IO,
  OUTFIT_VIBE_ARCH_IO = PageId.OUTFIT_VIBE_ARCH_IO,
  OUTFIT_COMPLIMENT_ARCH_IO = PageId.OUTFIT_COMPLIMENT_ARCH_IO,
  SHOP_PULLS_FIRST_ARCH_IO = PageId.SHOP_PULLS_FIRST_ARCH_IO,
  ARCHETYPE_LOADING_ARCH_IO = PageId.ARCHETYPE_LOADING_ARCH_IO,
  ARCHETYPE_RESULT_ARCH_IO = PageId.ARCHETYPE_RESULT_ARCH_IO,
  LOOKING_FEMININE_ARCH_IO = PageId.LOOKING_FEMININE_ARCH_IO,
  STYLES_FEEL_LIKE_YOU_ARCH_IO = PageId.STYLES_FEEL_LIKE_YOU_ARCH_IO,
  TALL_ARCH_IO = PageId.TALL_ARCH_IO,
  WEIGHT_ARCH_IO = PageId.WEIGHT_ARCH_IO,
  WARDROBE_CHANGED_ARCH_IO = PageId.WARDROBE_CHANGED_ARCH_IO,
  FAVORITE_COLORS_ARCH_IO = PageId.FAVORITE_COLORS_ARCH_IO,
  LIKE_OR_DISLIKE_11_ARCH_IO = PageId.LIKE_OR_DISLIKE_11_ARCH_IO,
  LIKE_OR_DISLIKE_14_ARCH_IO = PageId.LIKE_OR_DISLIKE_14_ARCH_IO,
  LIKE_OR_DISLIKE_15_ARCH_IO = PageId.LIKE_OR_DISLIKE_15_ARCH_IO,
  LIKE_OR_DISLIKE_18_ARCH_IO = PageId.LIKE_OR_DISLIKE_18_ARCH_IO,
  LIKE_OR_DISLIKE_19_ARCH_IO = PageId.LIKE_OR_DISLIKE_19_ARCH_IO,
  WALK_INTO_ROOM_ARCH_IO = PageId.WALK_INTO_ROOM_ARCH_IO,
  PERFECT_WEEKEND_ARCH_IO = PageId.PERFECT_WEEKEND_ARCH_IO,
  WARDROBE_FEEL_ARCH_IO = PageId.WARDROBE_FEEL_ARCH_IO,
  SHOPPING_ARCH_IO = PageId.SHOPPING_ARCH_IO,
  SHOPPING_BUDGET_ARCH_IO = PageId.SHOPPING_BUDGET_ARCH_IO,
  SHOPPING_PRIORITY_ARCH_IO = PageId.SHOPPING_PRIORITY_ARCH_IO,
  AMAZON_FRUSTRATION_ARCH_IO = PageId.AMAZON_FRUSTRATION_ARCH_IO,
  CURATED_LINKS_ARCH_IO = PageId.CURATED_LINKS_ARCH_IO,
  LIFESTYLE_FOCUS_ARCH_IO = PageId.LIFESTYLE_FOCUS_ARCH_IO,
  OUTFIT_NEEDS_ARCH_IO = PageId.OUTFIT_NEEDS_ARCH_IO,
  WARDROBE_ALIGNS_ARCH_IO = PageId.WARDROBE_ALIGNS_ARCH_IO,
  LIFESTYLE_CHANGES_ARCH_IO = PageId.LIFESTYLE_CHANGES_ARCH_IO,
  STYLE_DRAWN_TO_ARCH_IO = PageId.STYLE_DRAWN_TO_ARCH_IO,
  OUTFIT_EMOTION_ARCH_IO = PageId.OUTFIT_EMOTION_ARCH_IO,
  STYLE_DISCOVERY_ARCH_IO = PageId.STYLE_DISCOVERY_ARCH_IO,
  WARDROBE_COLORS_ARCH_IO = PageId.WARDROBE_COLORS_ARCH_IO,
  COLOR_CONFIDENCE_ARCH_IO = PageId.COLOR_CONFIDENCE_ARCH_IO,
  BODY_SHAPE_CONFIDENCE_ARCH_IO = PageId.BODY_SHAPE_CONFIDENCE_ARCH_IO,
  SHOW_OFF_FEATURES_ARCH_IO = PageId.SHOW_OFF_FEATURES_ARCH_IO,
  PREPARE_FLOW_ARCH_IO = PageId.PREPARE_FLOW_ARCH_IO,
  EMAIL_ARCH_IO = PageId.EMAIL_ARCH_IO,
  EMAIL_CONSENT_ARCH_IO = PageId.EMAIL_CONSENT_ARCH_IO,
  NAME_ARCH_IO = PageId.NAME_ARCH_IO,
  READINESS_LEVEL_ARCH_IO = PageId.READINESS_LEVEL_ARCH_IO,
  PRE_PAYWALL_OFFER_ARCH_IO = PageId.PRE_PAYWALL_OFFER_ARCH_IO,
  SUBSCRIPTIONS_ARCH_IO = PageId.SUBSCRIPTIONS_ARCH_IO,
  CANCEL_OFFER_ARCH_IO = PageId.CANCEL_OFFER_ARCH_IO,
  AI_STYLIST_UPSELL_ARCH_IO = PageId.AI_STYLIST_UPSELL_ARCH_IO,
  SUB_UPSELL_ARCH_IO = PageId.SUB_UPSELL_ARCH_IO,
  UPSELL_ARCH_IO = PageId.UPSELL_ARCH_IO,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
  DOWNLOAD_ARCH_IO = PageId.DOWNLOAD_ARCH_IO,
}
